import React, { Component } from "react";
import {
  Row,
  Col,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  InputGroup,
  FormFeedback,
  Alert,
  InputGroupText,
  InputGroupAddon,
} from "reactstrap";
import { Field, reduxForm, formValueSelector } from "redux-form/immutable";
import { Redirect, Link } from "react-router-dom";
import config from "../../../config";
import PasswordStrengthMeter from "../../commons/PasswordStrengthMeter";

export default class SetPassword3 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      validRegex: true,
      regexMessage: "",
      passwordType: "password",
      confirmPasswordType: "password",
      showPasswordState: false,
      showConfirmPasswordState: false,
      passwordInput: "",
    };
    this.showPassword = this.showPassword.bind(this);
    this.showConfirmPassword = this.showConfirmPassword.bind(this);
  }

  onPasswordChange = (e) => {
    const value = e.target.value;
    this.setState({ passwordInput: value });
    // Clear error related to backend failure here if needed
  };

  renderField({
    input,
    label,
    type,
    placeholder,
    showPasswordFunc,
    passwordType,
    meta,
    meta: { touched, error },
  }) {
    return (
      <FormGroup>
        <InputGroup>
          <InputGroupAddon addonType="prepend"></InputGroupAddon>
          <Input placeholder={placeholder} required type={type} {...input} />
          <div className="standard-line"></div>
          <Label for={input.name}>
            {label} <span className="asterick-mark">*</span>
          </Label>
          <div className="set-pass-show-btn" onClick={showPasswordFunc}>
            <i
              className={
                passwordType === "password" ? "fa fa-eye" : "fa fa-eye-slash"
              }
              aria-hidden="true"
              //style={{ color: "#675cff", fontSize: 18 }}
            ></i>
          </div>
        </InputGroup>

        {touched && error && (
          <small className="text-danger form-text mt-1 animated fadeIn">
            {/* <i className="fa fa-exclamation-triangle" aria-hidden="true"></i>{" "} */}
            {error}
          </small>
        )}
      </FormGroup>
    );
  }
  renderField2({
    input,
    label,
    type,
    placeholder,
    showPasswordFunc,
    passwordType,
    meta,
    meta: { touched, error },
  }) {
    const hasError = touched && error;
    return (
      <FormGroup>
        <InputGroup>
          <InputGroupAddon addonType="prepend"></InputGroupAddon>
          <Input
            placeholder={placeholder}
            required
            type={type}
            {...input}
            valid={hasError ? false : null}
          ></Input>
          <div className="standard-line"></div>
          <Label for={input.name}>
            {label} <span className="asterick-mark">*</span>
          </Label>
          <div className="set-pass-show-btn" onClick={showPasswordFunc}>
            <i
              className={
                passwordType === "password" ? "fa fa-eye" : "fa fa-eye-slash"
              }
              aria-hidden="true"
              //style={{ color: "#675cff", fontSize: 18 }}
            ></i>
          </div>
        </InputGroup>
      </FormGroup>
    );
  }
  setPasswordType(passwordType) {
    this.setState({ passwordType });
  }

  setConfirmPasswordType(confirmPasswordType) {
    this.setState({ confirmPasswordType });
  }

  showPassword() {
    this.setState({ showPasswordState: !this.state.showPasswordState });
    this.setPasswordType(this.state.showPasswordState ? "text" : "password");
  }

  showConfirmPassword() {
    this.setState({
      showConfirmPasswordState: !this.state.showConfirmPasswordState,
    });
    this.setConfirmPasswordType(
      this.state.showConfirmPasswordState ? "text" : "password"
    );
  }

  regexPattern = (pattern, message) => (value) => {
    const regex = new RegExp(pattern, "g");
    this.setState({ validRegex: regex.test(value) });
    if (!regex.test(value)) {
      this.setState({ regexMessage: message });
    }
    if (regex.test(value)) {
      this.setState({ regexMessage: "" });
    }
  };

  render() {
    const {
      setPasswordState,
      companyDetails,
      layoutItem,
      isSetPasswordIsHavingError,
      setPasswordErrorMsg,
    } = this.props;

    console.log("this.props", this.props);

    const { validRegex, regexMessage, passwordType, confirmPasswordType } =
      this.state;
    const setPasswordConfig =
      layoutItem &&
      layoutItem.itemProperties &&
      layoutItem.itemProperties.setPasswordConfig;
    const regexPatterns = setPasswordConfig && setPasswordConfig.regexPattern;
    const regexErrorMessage =
      setPasswordConfig && setPasswordConfig.regexErrorMessage;
    const enablePasswordStrengthMeter =
      setPasswordConfig && setPasswordConfig.enablePasswordStrengthMeter;
    let setPasswordValidation = [];
    if (regexPatterns) {
      setPasswordValidation.push(
        this.regexPattern(regexPatterns, regexErrorMessage)
      );
    }

    const templateSideImage =
      layoutItem &&
      layoutItem.itemProperties &&
      layoutItem.itemProperties.setPasswordConfig &&
      layoutItem.itemProperties.setPasswordConfig.templateSideImage &&
      layoutItem.itemProperties.setPasswordConfig.templateSideImage.path;

    const sideImageTopLogo =
      layoutItem &&
      layoutItem.itemProperties &&
      layoutItem.itemProperties.setPasswordConfig &&
      layoutItem.itemProperties.setPasswordConfig.sideImageTopLogo &&
      layoutItem.itemProperties.setPasswordConfig.sideImageTopLogo.path;

    const topHeadingLogo =
      layoutItem &&
      layoutItem.itemProperties &&
      layoutItem.itemProperties.setPasswordConfig &&
      layoutItem.itemProperties.setPasswordConfig.topHeadingLogo &&
      layoutItem.itemProperties.setPasswordConfig.topHeadingLogo.path;

    const sideImageTopLogoUrl = `${config.assetsBasePath}${sideImageTopLogo}`;
    const topHeadingLogoUrl = `${config.assetsBasePath}${topHeadingLogo}`;
    const authTemplateSideImage = `${config.assetsBasePath}${templateSideImage}`;

    const sideImageTextOne =
      layoutItem &&
      layoutItem.itemProperties &&
      layoutItem.itemProperties.setPasswordConfig &&
      layoutItem.itemProperties.setPasswordConfig.sideImageTextOne;

    const sideImageTextTwo =
      layoutItem &&
      layoutItem.itemProperties &&
      layoutItem.itemProperties.setPasswordConfig &&
      layoutItem.itemProperties.setPasswordConfig.sideImageTextTwo;

    const logoutUrl =
      companyDetails && companyDetails.data && companyDetails.data.logoutURL
        ? companyDetails.data.logoutURL
        : "/login";

    return (
      <div className="forgot-password-template-3 set-password-template-2">
        <div className="left-panel">
          {sideImageTopLogoUrl && (
            <img src={sideImageTopLogoUrl} className="left-logo" />
          )}
          <div className="left-para-sec">
            <p>
              {sideImageTextOne} <span>{sideImageTextTwo}</span>
            </p>
          </div>
          {authTemplateSideImage && (
            <img
              src={authTemplateSideImage}
              alt="payment-img"
              className="payment-bg-img"
            />
          )}
        </div>
        <div className="right-panel">
          <div className="inner-right-panel pb-5">
            {!setPasswordState.isLoading &&
            setPasswordState.data !== null &&
            !(isSetPasswordIsHavingError === "Failure") ? (
              <div className="alertText">
                <svg
                  class="checkmark"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 52 52"
                >
                  {" "}
                  <circle
                    class="checkmark__circle"
                    cx="26"
                    cy="26"
                    r="25"
                    fill="none"
                  />{" "}
                  <path
                    class="checkmark__check"
                    fill="none"
                    d="M14.1 27.2l7.1 7.2 16.7-16.8"
                  />
                </svg>
                <h4>Thank you for submitting the request!!</h4>
                <p>
                  If the email address is registered with us, you will receive
                  an email with link to reset the password.
                </p>
                <Link className="back-to-login-btn" to={logoutUrl}>
                  Continue to login
                </Link>
              </div>
            ) : (
              <Form onSubmit={this.props.setPassword}>
                <div className={`brand-logo`}>
                  {topHeadingLogoUrl && (
                    <img src={topHeadingLogoUrl} alt="Image" />
                  )}
                </div>
                <div className="forgot-pass-div">
                  <h3>Reset Password</h3>
                  <div className="input-sec mb-4">
                    <i
                      className={`fa fa-lock forgot-icon`}
                      aria-hidden="true"
                    ></i>
                    <Field
                      name="password"
                      component={this.renderField2}
                      type={passwordType}
                      label="Password"
                      placeholder="Enter your password"
                      validate={setPasswordValidation}
                      showPasswordFunc={this.showPassword}
                      passwordType={passwordType}
                      onChange={this.onPasswordChange}
                    />
                  </div>
                  <div className="input-sec mt-4 mb-3">
                    <i
                      className={`fa fa-lock forgot-icon`}
                      aria-hidden="true"
                    ></i>
                    <Field
                      name="confirmPassword"
                      component={this.renderField}
                      type={confirmPasswordType}
                      label="Confirm Password"
                      placeholder="Enter your confirm password"
                      showPasswordFunc={this.showConfirmPassword}
                      passwordType={confirmPasswordType}
                    />
                  </div>

                  {enablePasswordStrengthMeter && this.state.passwordInput && (
                    <div className="password-checker-sec">
                      <PasswordStrengthMeter
                        password={this.state.passwordInput}
                      />
                      <div className="line-1"></div>
                      <div className="line-2"></div>
                    </div>
                  )}

                  {!validRegex && regexMessage.length > 0 ? (
                    <FormFeedback className="animated fadeIn d-block">
                      {regexMessage}
                    </FormFeedback>
                  ) : isSetPasswordIsHavingError === "Failure" &&
                    setPasswordErrorMsg ? (
                    <FormFeedback className="animated fadeIn d-block">
                      {setPasswordErrorMsg}
                    </FormFeedback>
                  ) : null}

                  <Button
                    disabled={setPasswordState.isLoading || !validRegex}
                    className="forgot-btn"
                    color="primary"
                    block
                  >
                    {setPasswordState.isLoading
                      ? "Please wait..."
                      : "Set Password"}
                  </Button>
                  <span className="back-login-link">
                    {`Already registered user?`} &nbsp;
                    <Link to={logoutUrl}>Click here</Link>
                  </span>
                </div>
              </Form>
            )}
          </div>
        </div>
      </div>
    );
  }
}
